import PropTypes from 'prop-types';

import './nameValuePairs.scss';

export default function NameValuePairs ({items = []}) {
  return (
    <div className='name-value-pairs'>
      {
        items.map((item, index) => {
          return (
            <span key={index} className='name-value-pair'>
              <span>{item.label + ':'} </span>
              <span>{item.value ?? ''}</span>
            </span>
          )
        })
      }
    </div>
  )
}

NameValuePairs.propTypes = {
  items : PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.any,
  })
  )
};
